export function StorySection() {
  return (
    <section id="story" className="py-20 bg-warm-beige">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-earth-green mb-6 handwriting">
                麻薏湯的在地故事
              </h2>
              <div className="space-y-6 text-tea-brown leading-relaxed">
                <p className="text-lg">
                  在台中，每到夏天，巷口的阿婆就會開始賣麻薏湯。這是用黃麻嫩葉細心熬煮的古早味，有著淡淡的苦味，卻能消暑退火，是在地人最熟悉的味道。
                </p>
                <p className="text-lg">
                  就像麻薏湯需要時間慢慢熬煮，企業的數位轉型也需要耐心與陪伴。我們用麻薏的名字，是希望能像這碗湯一樣，帶給企業最實在、最溫暖的支持。
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start space-x-4 p-4 bg-white rounded-lg warm-shadow">
                <div className="w-8 h-8 bg-earth-green rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-seedling text-cream text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-earth-green mb-1 handwriting">
                    傳統與創新
                  </h4>
                  <p className="text-tea-brown text-sm">
                    保持台中人的樸實個性，結合最新的 AI 技術
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white rounded-lg warm-shadow">
                <div className="w-8 h-8 bg-earth-green rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-users text-cream text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-earth-green mb-1 handwriting">
                    社區共好
                  </h4>
                  <p className="text-tea-brown text-sm">
                    參與智在家鄉計畫，希望帶動整個社區一起進步
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white rounded-lg warm-shadow">
                <div className="w-8 h-8 bg-earth-green rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-heart text-cream text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-earth-green mb-1 handwriting">
                    用心服務
                  </h4>
                  <p className="text-tea-brown text-sm">
                    每一家企業都是我們的鄰居，用心陪伴每一步成長
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-earth-green rounded-2xl p-8 text-cream shadow-2xl">
              <div className="text-center space-y-6">
                <div className="w-20 h-20 bg-cream/20 rounded-full flex items-center justify-center mx-auto">
                  <i className="fas fa-leaf text-3xl text-cream"></i>
                </div>
                <h3 className="text-2xl font-bold handwriting">我們的承諾</h3>
                <div className="space-y-4 text-cream/90">
                  <p className="text-lg leading-relaxed handwriting">
                    「不管企業大小，每一家都值得最好的服務」
                  </p>
                  <div className="bg-cream/20 rounded-lg p-4">
                    <p className="text-sm">
                      從一人工作室到百人企業，我們都會用同樣的用心，陪伴您走向數位轉型的每一步。
                    </p>
                  </div>
                </div>

                <div className="border-t border-cream/20 pt-6">
                  <p className="text-sm italic handwriting">
                    "就像鄰居阿婆會關心您今天有沒有吃飽，我們也會關心您的生意有沒有越來越好。"
                  </p>
                  <p className="text-xs mt-2 opacity-75">- 麻薏 AI 團隊</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
